import React from "react";
import ReactDOM from "react-dom";
import HttpsRedirect from "react-https-redirect";
import { browserHistory } from "react-router";
import { StripeProvider } from "react-stripe-elements";

import Routes from "./routes";
const App = () => (
  <HttpsRedirect>
    <StripeProvider apiKey="pk_live_S53NyoWPhWITRAKgRpMW4fgB">
      <Routes history={browserHistory} />
    </StripeProvider>
  </HttpsRedirect>
);

ReactDOM.render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// src/index.js